
    import { Component, Vue } from "vue-facing-decorator";

    @Component({})
    export default class About extends Vue {
    }
